/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-10.
 * Form configuration for "aduana"
 */
import {
    SELECT,
    TEXT
} from '../components/data-containers/formBuilder/types';
import { APPLICABLE_INVOICE_ITEMS } from '../data/selects';


export const getConfig = (actions = {}) => {
    return {
        fields: [
            {
                fType: TEXT,
                key: 'concept',
                floatingLabelFixed: true,
                floatingLabelText: 'Concepto',
                hintText: 'Previo Ocular',
                fullWidth: true
            },
            {
                fType: SELECT,
                key: 'applicable',
                floatingLabelText: 'Aplicable',
                floatingLabelFixed: true,
                data: APPLICABLE_INVOICE_ITEMS
            },
            {
                fType: TEXT,
                key: 'tax',
                floatingLabelFixed: true,
                floatingLabelText: 'IVA %',
                hintText: 'Porcentaje (%)',
                value: 16,
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'aditionalTax',
                floatingLabelFixed: true,
                floatingLabelText: 'Impuesto adicional %',
                hintText: 'Porcentaje (%)',
                fullWidth: true,
                value: 0.0
            },
            {
                fType: TEXT,
                key: 'retentions',
                floatingLabelFixed: true,
                floatingLabelText: 'Retención %',
                hintText: 'Porcentaje (%)',
                fullWidth: true,
                value: 0.0
            }
        ],
        rules: {
            concept: [{ key: 'required', errorText: 'Campo requerido' }],
            applicable: [{ key: 'required', errorText: 'Campo requerido' }],
            tax: [{ key: 'onlyNumbers', errorText: 'Solo números enteros' }, { key: 'validationInvoiceItem', errorText: 'El impuesto puede tener 9 digitos maximo' }],
            aditionalTax: [{ key: 'onlyNumbers', errorText: 'Solo números enteros' }, {key: 'validationInvoiceItem', errorText: 'El impuesto adicional puede tener 9 digitos maximo'}],
            retentions: [{ key: 'percentajeValues', errorText: 'Por favor no agrege letras ni signos' }, {key: 'validationInvoiceItem', errorText: 'Las retenciones pueden  tener 9 digitos maximo'}]
        }
    };
};



// WEBPACK FOOTER //
// ./forms/concepto.js